module.exports = __webpack_public_path__ + "img/timeline_error.e1d8ae4b.svg";